import styled from '@emotion/styled';

const Section = styled.section``;

export default Section;
